import HttpService from './HttpService';

export default {
  async obtenerFotoPerfil(idUsuario) {
    try {
      const payload = {
        metodo: 'obtener_foto_perfil',
        idUsuario: idUsuario
      };
      
      const resultado = await HttpService.obtenerConDatos(payload, 'usuarios.php');
      return resultado;
    } catch (error) {
      console.error('Error al obtener foto de perfil:', error);
      return { resultado: false, fotoPerfil: null };
    }
  },

  async actualizarFotoPerfil(idUsuario, fotoPerfil) {
    try {
      const payload = {
        metodo: 'actualizar_foto_perfil',
        idUsuario: idUsuario,
        fotoPerfil: fotoPerfil
      };
      
      const resultado = await HttpService.obtenerConDatos(payload, 'usuarios.php');
      
      // Si se actualizó correctamente, también actualizar localStorage
      if (resultado.resultado) {
        localStorage.setItem(`fotoPerfil_${idUsuario}`, fotoPerfil);
        // Disparar evento para notificar cambio
        window.dispatchEvent(new CustomEvent('userChanged'));
      }
      
      return resultado;
    } catch (error) {
      console.error('Error al actualizar foto de perfil:', error);
      return { resultado: false, mensaje: 'Error al actualizar la foto' };
    }
  },

  // Método para cargar foto desde la base de datos al localStorage
  async cargarFotoEnLocalStorage(idUsuario) {
    const resultado = await this.obtenerFotoPerfil(idUsuario);
    
    if (resultado.resultado && resultado.fotoPerfil) {
      localStorage.setItem(`fotoPerfil_${idUsuario}`, resultado.fotoPerfil);
      window.dispatchEvent(new CustomEvent('userChanged'));
      return true;
    }
    
    return false;
  }
};



// WEBPACK FOOTER //
// ./src/Servicios/FotoPerfilService.js